import React from "react";
import { Dialog, DialogActions,DialogContent, DialogContentText, DialogTitle, Button, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';
import WarningAmber from '@mui/icons-material/WarningAmber';



const Popup=({open,handleClose,handleYes,handleNo,title,message,buttonNo,buttonYes,warningSignWithMessage,key1,key2,key3,value1,value2,value3,severity,calledfrom,disabledButton})=>{

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
          padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
          padding: theme.spacing(1),
        },
      }));

      console.log("disble",disabledButton)

    return(
        <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
         <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
            
            <DialogTitle sx={{ m: 0, p: 1,backgroundColor:'#002677',color:'white',fontWeight:'bold',textAlign:'center'}} id='customized-dialog-title'>{title}</DialogTitle>
            {calledfrom==='intermediateFormPopUp'?(

            <DialogContent dividers>
                <DialogContentText sx={{color:'black',fontWeight:'bold' }}id="alert-dialog-description">
                    {message}
                </DialogContentText>
                <DialogContentText sx={{color:'black',display:'inline-block',fontWeight:'bold'}}id="alert-dialog-description">
                    {key1}
                </DialogContentText>
                <DialogContentText sx={{color:'grey',display:'inline-block', paddingLeft: "3%",textDecoration:'underline',fontWeight:'bold'}}id="alert-dialog-description">
                    {value1}
                </DialogContentText>
                <br></br>
                <DialogContentText sx={{color:'black',display:'inline-block',fontWeight:'bold'}}id="alert-dialog-description">
                    {key2}
                </DialogContentText>
                <DialogContentText sx={{color:'grey',display:'inline-block', paddingLeft: "3%",textDecoration:'underline',fontWeight:'bold'}}id="alert-dialog-description">
                    {value2}
                </DialogContentText>
                <br></br>
                <DialogContentText sx={{color:'black',display:'inline-block',fontWeight:'bold'}}id="alert-dialog-description">
                    {key3}
                </DialogContentText>
                <DialogContentText sx={{color:'grey',display:'inline-block', paddingLeft: "3%",textDecoration:'underline',fontWeight:'bold'}}id="alert-dialog-description">
                    {value3}
                    </DialogContentText>
                
            </DialogContent>):(            <DialogContent dividers>
              <DialogContentText sx={{color:'black',fontWeight:'bold'}}id="alert-dialog-description">
                    {message}
                </DialogContentText>
                <DialogContentText sx={{color:'grey',fontWeight:'bold',textDecoration:'underline',whiteSpace:'pre-line'}}id="alert-dialog-description">
                    {value1}
                </DialogContentText>

              </DialogContent>
)}


            <DialogContent sx={{backgroundColor:'#e5f3fd'}}>
        {calledfrom==='homeTablePopUp' ?(<WarningAmber sx={{color:'#8B4513'}}/> ):
        (            <InfoIcon sx={{color:'darkblue'}}/>
        )
        }
            <DialogContentText sx={{display:"inline",color:"red",fontWeight:"bold"}}>
             {severity}
            </DialogContentText>
            <Typography gutterBottom sx={{color:'#284fa1'}}>
                    {warningSignWithMessage}
                </Typography>
                </DialogContent>    
            <DialogActions>
                <Button onClick={handleNo}color='primary'sx={{backgroundColor:'white'}}>
                  {buttonNo}
                </Button>
                <Button onClick={handleYes}color='primary'autoFocus disabled={disabledButton?disabledButton.current:""}>
                    {buttonYes}
                </Button>
            </DialogActions>
         </Dialog>
         </BootstrapDialog>

    );
};
export default Popup;